export class AuthenticationData {

	public tokenType: string;
	public accessToken: string;
	public refreshToken: string;
	public jwt: any;

	constructor() { }

	getAuthHeader(): string {
		if (this.tokenType == null || this.accessToken == null) {
			return "";
		}

		return this.tokenType + ' ' + this.accessToken;
	}

	getToken(): string {
		if (this.tokenType == null || this.accessToken == null) {
			return "";
		}

		return this.accessToken;
	}

	copy(data: AuthenticationData) {
		this.tokenType = data.tokenType;
		this.accessToken = data.accessToken;
		this.refreshToken = data.refreshToken;
		this.jwt = data.jwt;
	}

	set(tokenType: string, accessToken: string, refreshToken: string, jwt: string) {
		this.tokenType = tokenType;
		this.accessToken = accessToken;
		this.refreshToken = refreshToken;
		this.jwt = jwt;
	}
}